import axios from 'axios';
import store from '../redux/store/store';

// API URL'si environment değişkenlerinden alınıyor
const API_TRANSFER_URL = import.meta.env.VITE_API_URL;

const productTranssferService = {
  fetchProductTransfer: async (productIds,selectedPlatform,selectedPlatformType) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      let ecommercePlaceId=0;
      let marketPlaceId=0;
      if(selectedPlatformType=="ecommerce"){
        ecommercePlaceId=selectedPlatform
      }else{
        marketPlaceId=selectedPlatform
      }
      const response = await axios.get('/ProductPlaceTransfer', {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
        params: {
          MarketPlaceId:marketPlaceId,
          EcommercePlaceId:ecommercePlaceId,
          ProductIds: productIds.join(","),
        },
      });
      return response?.data;
    } catch (error) {
      console.error('Error fetching product transfer:', error);
      throw error;
    }
  },



  fetchProductPleaces: async (productIds, selectedPlatform, selectedPlatformType) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
  
      let ecommercePlaceId = 0;
      let marketPlaceId = 0;
      if (selectedPlatformType === "ecommerce") {
        ecommercePlaceId = selectedPlatform;
      } else {
        marketPlaceId = selectedPlatform;
      }
  
      // 1) URLSearchParams ile query parametresini oluştur
      const queryParams = new URLSearchParams();
  
      // MarketPlaceId ve EcommercePlaceId ekleme
      if (marketPlaceId) {
        queryParams.append('MarketPlaceId', marketPlaceId);
      }
      if (ecommercePlaceId) {
        queryParams.append('EcommercePlaceId', ecommercePlaceId);
      }
  
      // productIds (ör. [144970, 144969, 144968]) her biri ayrı parametre olacak
      productIds.forEach((id) => {
        queryParams.append('ProductIds', id); 
        // Böylece ?ProductIds=144970&ProductIds=144969&ProductIds=144968
      });
  
      // 2) Oluşturduğumuz query string’i endpoint’e ekle
      const url = '/ProductPlace?' + queryParams.toString();
  
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      });
  
      return response?.data;
    } catch (error) {
      console.error('Error fetching product transfer:', error);
      throw error;
    }
  },
  
};



export default productTranssferService;